import React from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Button } from "react-bootstrap";

import paginationFactory from "react-bootstrap-table2-paginator";
import Axios from "axios";
import cellEditFactory from "react-bootstrap-table2-editor";
import HelloStateful from './HelloStateful';
import HelloForm from './HelloForm';


/* import Alert from 'react-bootstrap/Alert';
import HelloForm from './HelloForm'; */

const { SearchBar } = Search;
const api_key = process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV === 'servcomp-hml' ? process.env.REACT_APP_CONSULTADANFE_PROD : process.env.REACT_APP_CONSULTADANFE_HOM;
const api_pedido = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PEDIDO_PROD : process.env.REACT_APP_PEDIDO_HOM ;
const api_pedido_uni = process.env.REACT_APP_PEDIDOUNI;
//console.log (api_key);
//console.log (api_pedido);
console.log (process.env.REACT_APP_ENV);

let codigolojafilter;
let numerodanfefilter;

const ClearButton = props => {
  const handleClick = () => {
    props.onSearch("");
    props.clearAllFilter();
   
  };
  
  return (
    <Button
      variant="secondary"
      onClick={handleClick}
     
      style={{
        fontSize: "16px",
        padding: "5px",
        margin: "10px",
        height: "40px"
      }}
    >
      Clear
    </Button>
  );
};

const SearchButton = props => {
  const handleClick = (event) => {

    alert("clicou aqui");
    const data = this.state
    console.log(data);
   
  };
  
  return (
    <Button
      variant="secondary"
      onClick={handleClick}
     
      style={{
        fontSize: "16px",
        padding: "5px",
        margin: "10px",
        height: "40px"
      }}
    >
      Pesquisa
    </Button>
  );
};



        class DanfeListFilter extends React.Component {


            handleEdit = (id, des_nome, cod_cnpj_cpf, codigo_loja, cell, row, rowIndex) => {           
                
                console.log('Product #', rowIndex);
                this.setState({
                  disabled: true
                })
               
               // console.log(pedido3);
              };

            state = {
                rows: [],
                param: ''
              };
      
          
            componentDidMount() {
                fetch(api_key)
                    .then(res => res.json())
                    .then(res => {
                        this.setState({
                            rows: res
                        });
                    }).catch(erro => {
                      console.log( erro );
                    });
            }

            handleApi = (id, des_nome, cod_cnpj_cpf, 
              codigo_loja, valor_total, des_endereco,
              des_bairro, des_municipio, uf_cliente,
              cod_cep, email, ddd, fone,
              companynumber, originsystem, customertype,
              documenttype, operatorcode, productcode, 
              saleunit, imei, automationcode,
              externalOrderCode, numero_danfe, des_produto,
              qtd_item, valor_unitario, serie) => {
                console.log("Api Call clicked", id);
                
                const pedido3 =  {companyNumber:companynumber,
              orderNumber:null,
              originSystem:originsystem,
              status:"NEW", 
              storeNumber: codigo_loja,
              totalValue:valor_total,
              customer:{
              customerId: cod_cnpj_cpf,
              customerType:customertype,
              document: cod_cnpj_cpf,
              documentType:documenttype,
              email:email,
              name: des_nome,
              address:{
                  addressComplement:"",
                  addressName:des_endereco,
                  addressNumber:"",
                  city:des_municipio,
                  cityCode:null,
                  country:"BR",
                  neighborhood:des_bairro,
                  phone:fone,
                  state:uf_cliente,
                  zipCode:cod_cep
              }
              },
              fiscalCustomerId:null,
              operatorCode:operatorcode,
              fiscalItems:[
              {
                  sequenceId:1,
                  externalOrderCode:"",
                  externalSequenceId:automationcode,
                  productCode:productcode,
                  automationCode:automationcode,
                  customerLoyaltyProgramCode: numero_danfe, 
                  salesAssociateNumber:null,
                  productDescription:des_produto,
                  productCompactDescription:des_produto,
                  deliveryOption:"PICK_UP_FROM_WAREHOUSE",
                  imei:"",
                  materialOrigin:"0",
                  unitValue:valor_unitario,
                  quantitySold:qtd_item,
                  totalValue:valor_total,
                  unitQuantity:qtd_item,
                  saleUnit:saleunit,
                  cbModality:0,
                  discounts:[
                  ]
              }
              ],
              nonFiscalItems:[
    
              ],
              discounts:[
    
              ]};

                console.log(pedido3);

                  Axios.post(api_pedido, pedido3)
                  .then(response => { 
                      console.log(response);

                      const geraPedUnicom =  {codigo_loja: codigo_loja,
                        numero_nf:numero_danfe,
                        serie_nf:serie,
                        cpf_cnpj:cod_cnpj_cpf,
                        pedido: response.data.orderNumber,
                        detalhe: null}; 

                        console.log (geraPedUnicom);

                      Axios.post(api_pedido_uni, geraPedUnicom)
                      .then(response => {
                        console.log(response);
                        alert("Pedido "+response.data.orderNumber+ " Gerado com sucesso");
                      }).catch(error => {
                        console.log(error.response);
                        alert(error.response.data.message);
                      })
                  })
                  .catch(error => {
                      console.log(error.response);
                      alert(error.response.data.message);
                  });


             };



            editButton = (cell, rows, enumObject, rowIndex) => {
              if (rows.pedido === '0') {
                return (
                <Button id={rows.id} onClick={() => this.handleEdit(rows.id, rows.des_nome, rows.cod_cnpj_cpf, rows.codigo_loja, cell, rowIndex)} >Edit</Button>
                )
              } else {
                return (
                <Button id={rows.id} disabled onClick={() => this.handleEdit(rows.id, rows.des_nome, rows.cod_cnpj_cpf, rows.codigo_loja)} >Edit</Button>
                )
              }
  
              
            }
              apiButton = (cell, rows, enumObject, rowIndex) => {

                if (rows.pedido ==='0') {
                  return (
                    <Button id={rows.id} onClick={() => this.handleApi(rows.id, rows.des_nome, rows.cod_cnpj_cpf, 
                      rows.codigo_loja, rows.valor_total, rows.des_endereco,
                      rows.des_bairro, rows.des_municipio, rows.uf_cliente,
                      rows.cod_cep, rows.email, rows.ddd, rows.fone,
                      rows.companynumber, rows.originsystem, rows.customertype,
                      rows.documenttype, rows.operatorcode, rows.productcode, 
                      rows.saleunit, rows.imei, rows.automationcode,
                      rows.externalOrderCode, rows.numero_danfe, rows.des_produto,
                      rows.qtd_item, rows.valor_unitario, rows.serie)                                                           
                      }  >Gerar Pedido
                    </Button>
                  )
                } else {
                  return (
                    <Button id={rows.id} disabled onClick={() => this.handleApi(rows.id, rows.des_nome, rows.cod_cnpj_cpf, 
                      rows.codigo_loja, rows.valor_total, rows.des_endereco,
                      rows.des_bairro, rows.des_municipio, rows.uf_cliente,
                      rows.cod_cep, rows.email, rows.ddd, rows.fone,
                      rows.companynumber, rows.originsystem, rows.customertype,
                      rows.documenttype, rows.operatorcode, rows.productcode, 
                      rows.saleunit, rows.imei, rows.automationcode,
                      rows.externalOrderCode, rows.numero_danfe, rows.des_produto,
                      rows.qtd_item, rows.valor_unitario, rows.serie )                                                           
                      }  >Gerar Pedido
                    </Button>
                  
                  )
                }
                
            
              };
            columns = [
                {
                  dataField: "codigo_loja",
                  text: "Loja",
                  filter: textFilter({
                    getFilter: filter => {
                        codigolojafilter = filter;
                    }
                  })
                },
                {
                  dataField: "des_nome",
                  text: "Cliente",
                  sort: true
                },
                {
                  dataField: "numero_danfe",
                  text: "DANFE",
                  filter: textFilter({
                    getFilter: filter => {
                        numerodanfefilter = filter;
                    }
                  })
                },
                {
                  dataField: "pedido",
                  text: "Pedido"
                },
                {
                    dataField: "data_emissao",
                    text: "Data de Emissão"

                  },
                  {
                    dataField: "status",
                    text: "Status"

                  },
                  {
                    dataField: "api",
                    text: "Actions",
                    isDummyField: true,
                    csvExport: false,
                    formatter: this.apiButton.bind(this) 
                  }/* ,  
                  {
                    dataField: "edit",
                    text: "Actions",
                    isDummyField: true,
                    csvExport: false,
                    formatter: this.editButton.bind(this) 
                  } */
                  
            ];
            
                clearAllFilter() {
                codigolojafilter("");
                numerodanfefilter("");
                }


                render() {
                const selectRow = {
                    mode: "checkbox",
                    clickToSelect: true
                  }                

           
                return (
                  <div>
                    <h1>Pesquisa</h1>
                   
                    <ToolkitProvider
                      bootstrap4
                      keyField="id"
                      data={this.state.rows}
                      columns={this.columns}
                      search
                    >
                      {props => (


                        <div>
            
                          <HelloStateful nome="outro nome"></HelloStateful>
                          <HelloForm exibeAlerta={this.exibirAlerta}></HelloForm>
                          Digite o texto: <input type= 'text' placeholder='teste' name='numero_danfe'/>
                           <SearchButton
                            exibeAlerta={this.exibirAlerta}
                            
                          /> 
                          <SearchBar
                            {...props.searchProps}
                            style={{ width: "400px", height: "40px" }}
                          />
                          <ClearButton
                            {...props.searchProps}
                            clearAllFilter={this.clearAllFilter}
                          />

                          <BootstrapTable
                            {...props.baseProps}
                            filter={filterFactory()}
                            noDataIndication="There is no solution"
                            striped
                            hover
                            condensed
                            pagination={paginationFactory({})}
                            
                            selectRow={selectRow}
                            cellEdit={cellEditFactory({ mode: "click" })}
                            
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                );
              }

            
        }

export default DanfeListFilter;